import Vue from "vue";
import Vuex from "vuex";
import route from "./router.js";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    user: {
      name: "",
      role: "",
      id: "",
    },
    generalMessage: {
      text: "",
      type: "",
    },
    isAuthorised: false,
    requirementModal: {
      visible: false,
      id: "",
    },
    offerModal: {
      visible: false,
      id: "",
    },
    userMessage: {
      type: "",
      content: "",
    },
    activeRequirementId: "",
    showLoader: false,
  },
  mutations: {
    setUserData(state, val) {
      state.user = val;
    },
    setGeneralMessage(state, val) {
      state.generalMessage = val;
    },
    setActiveRequirementModal(state, val) {
      state.requirementModal = val;
      if (val.id) {
        state.activeRequirementId = val.id;
      }
    },
    setActiveRequirementId(state, val) {
      state.activeRequirementId = val;
    },
    setActiveOfferModal(state, val) {
      state.offerModal = val;
    },
    setMessage(state, val) {
      state.userMessage = val;
    },
    clearMessage(state, val) {
      state.userMessage = null;
    },
    setLoadingAnimation(state, val) {
      if (!val) {
        state.showLoader = false;
        state.loaderText = "";
      } else {
        state.showLoader = val.show;
        state.loaderText = val.text;
      }
    },
  },
  actions: {
    async getRequest({ commit }, data) {
      var url = data.method ? `/${data.controller}/${data.method}` : `/${data.controller}`;
      if (data.parameters) {
        url += "?";
        for (var key in data.parameters) {
          if (data.parameters.hasOwnProperty(key)) {
            url += `${key}=${data.parameters[key]}&`;
          }
        }
      }

      return await axios
        .get(`${process.env.VUE_APP_API_URL}/${url}`)
        .then(function(response) {
          return response.data;
        })
        .catch((error) => {
          const response = error.response;
          if (response && response.status == 500) {
            if (response.data.error) {
              commit("setUserMessage", {
                title: "Unable to Update",
                type: "error",
                content: response.data.error,
              });
            }
          } else if (!response || response.status == 401) {
            return store.dispatch("onNotAuthenticated");
          } else {
            return false;
          }
        });
    },
    async postRequest({ commit }, data) {
      var url = `${process.env.VUE_APP_API_URL}/${data.controller}/${data.method}`;
      var formData = new FormData();
      if (data.form) {
        for (var key in data.parameters) {
          if (data.parameters.hasOwnProperty(key)) {
            if (data.parameters[key]) {
              formData.append(key, data.parameters[key]);
            }
          }
        }
      }
      let response = await axios
        .post(url, data.form ? formData : data.parameters)
        .then(function(response) {
          if (data.documents) {
            return response;
          }
          if (response.data) {
            return response.data;
          } else if (response.success === false) {
            return {
              success: false,
              message: response.Message,
            };
          } else {
            return true;
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status == 500) {
            if (response.data.Message) {
              commit("setMessage", {
                type: "error",
                content: response.data.Message,
              });
            }
          } else if (response.status == 401) {
            return store.dispatch("onNotAuthenticated");
          } else {
            return false;
          }
        });
      return response;
    },
    async onNotAuthenticated({ commit }) {
      store.commit("setUserData", null);
      return false;
    },
    async attemptLogin({ state, commit }, data) {
      var formData = new FormData();
      formData.append("email", data.email);
      formData.append("password", data.password);
      var url = `${process.env.VUE_APP_API_URL}/portal/login`;
      var self = this;
      axios
        .post(url, formData)
        .then(function(response) {
          if (response.data.success) {
            store.commit("setUserData", response.data.data);
            localStorage.setItem("loggedIn", true);
            state.isAuthorised = true;
            route.push("/requirements");
          } else {
            localStorage.setItem("loggedIn", false);
            store.commit("setUserData", null);
          }
        })
        .catch(function(error) {
          localStorage.setItem("loggedIn", false);
          store.commit("setUserData", null);
        });
    },
    async authenticate({ state, commit }) {
      var url = `${process.env.VUE_APP_API_URL}/portal/Authorize`;
      state.isAuthorizing = true;
      let response = await axios.get(url).catch(() => {
        commit("setUserData", null);
      });
      if (response && response.data.success) {
        commit("setUserData", response.data.data);
        state.isAuthorised = true;
        localStorage.setItem("loggedIn", true);
      }
      return response;
    },
    async tokenLogin({ state, commit }) {
      this.isSettingPassword = false;
      var self = this;
      var url = `${process.env.VUE_APP_API_URL}/sso/SeaProjectsLogin?token=${route.currentRoute.query.token}`;

      axios
        .post(url)
        .then(function(response) {
          if (response.data.success) {
            commit("setUserData", response.data.data);
            localStorage.setItem("loggedIn", true);
            state.isAuthorised = true;
            route.push("/requirements");
          } else {
            localStorage.setItem("loggedIn", false);
            store.commit("setUserData", null);
          }
        })
        .catch(function(error) {
          localStorage.setItem("loggedIn", false);
          store.commit("setUserData", null);
          console.log("Error logging in");
        });
    },
    async logout({ state, commit }) {
      localStorage.removeItem("loggedIn");
      commit("setUserDetails", null);
      commit("setAuthenticated", false);
      state.isAuthorised = false;
      var url = `${process.env.VUE_APP_API_URL}/portal/logout`;
      route.push("/login");
      return axios.get(url).catch(() => {});
    },
  },
  getters: {
    getAuthorized: (state) => {
      return state.isAuthorised;
    },
  },
});
export default store;
